import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { acceptCookies, denyCookies } from "../../../../Shared/utils/datalayer.mapping";
import { DataLayer } from "../../../custom_utils/datalayer";
import { Cookiebar } from "./cookiebar";
// FramedCookiebar() does not render <Cookiebar/> when the website is being displayed
// in an iframe. This is because the website is iframed in public librarian computers
// who do not support cookies. Origin of iframe: https://cmsv2.beesmart.nl/.
export const FramedCookiebar = (props)=>{
    if (window === window.top) return /*#__PURE__*/ _jsx(Cookiebar, {
        ...props
    });
};
export const acceptAllCookies = (callback)=>{
    acceptCookies();
    DataLayer.cookies("accept");
    if (callback) callback();
    location.reload();
};
export const denyAllCookies = (callback)=>{
    denyCookies();
    DataLayer.cookies("declined");
    if (callback) callback();
    location.reload();
};
